import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { SubscribeManager } from '../class/subscribe-manager.class';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentalDataSourceDashGroupsService extends SubscribeManager<string[]> {
  private environmentalDataSourceDashGroupsSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  public getEnvironmentalDataSourceDashGroups(): Observable<string[] | null> {
    return this.environmentalDataSourceDashGroupsSubject.asObservable();
  }

  public setEnvironmentalDataSourceDashGroups(groups: string[]): void {
    this.environmentalDataSourceDashGroupsSubject.next(groups);
    this.pushChange(groups);
  }

  public clearEnvironmentalDataSourceDashGroups(): Observable<null> | null {
    localStorage.removeItem('environmentalDataSources');
    this.environmentalDataSourceDashGroupsSubject.next([]);
    return null;
  }
}
